import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { AVATAR_LIST } from 'src/constants/queryKeys';

export const networkGetAvatarInfo = async (avatarId) => {
  const res = await axiosInstance.post(`Avatar/Info/${avatarId}`);
  return res;
};

export const networkGetAvatarList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`Avatar/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchAvatarList(payload, pageIndex, pageSize) {
  return useQuery({
    queryKey: [AVATAR_LIST, payload, pageIndex],
    queryFn: () => {
      return networkGetAvatarList(payload, pageIndex, pageSize);
    },
  });
}

export const networkCreateAvatar = async (data) => {
  const res = await axiosInstance.post('Avatar/Insert', data);
  return res;
};

export const networkUpdateAvatar = async (avatarId, data) => {
  const res = await axiosInstance.post(`Avatar/Update/${avatarId}`, data);
  return res;
};

export const networkRemoveAvatar = async (avatarId) => {
  const res = await axiosInstance.post(`Avatar/Remove/${avatarId}`);
  return res;
};
